export default __webpack_public_path__ + "static/11-robot-b8aaf0bf26f3ad4f618eff74c934bfcc.png";